import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { MailX, MailCheck, Loader2, AlertTriangle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const u = params.get("u") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/newsletter/unsubscribe", { params: { token, u } })
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Tautan tidak valid"));
  }, [token, u]);

  const act = async (path) => {
    setBusy(true);
    try {
      const r = await api.post(`/newsletter/${path}`, { token, u });
      setInfo({ ...info, opted_out: r.data.opted_out });
      toast.success(r.data.opted_out ? "Anda tidak akan menerima email lagi" : "Email diaktifkan kembali");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal memproses");
    }
    setBusy(false);
  };

  return (
    <div className="max-w-lg mx-auto px-4 py-24 relative z-10 text-center" data-testid="unsubscribe-page">
      {error ? (
        <div className="card p-8" data-testid="unsubscribe-error">
          <AlertTriangle className="w-12 h-12 text-amber-400 mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-black">Tautan Tidak Valid</h1>
          <p className="text-slate-400 mt-2 text-sm">{error}</p>
          <Link to="/profile" className="btn-ghost mt-6 inline-flex">Kelola dari Profil</Link>
        </div>
      ) : !info ? (
        <Loader2 className="w-8 h-8 animate-spin text-cyan1 mx-auto" />
      ) : info.opted_out ? (
        <div className="card p-8" data-testid="unsubscribe-done">
          <MailX className="w-12 h-12 text-magenta1 mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-black">Email Dihentikan</h1>
          <p className="text-slate-400 mt-2 text-sm">
            <span className="font-mono text-slate-300">{info.email}</span> tidak akan menerima digest maupun notifikasi berita lagi.
            Akses arsip digest di situs tetap aktif.
          </p>
          <button onClick={() => act("resubscribe")} disabled={busy} className="btn-ghost mt-6" data-testid="resubscribe-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <MailCheck className="w-4 h-4" />} Aktifkan Kembali
          </button>
        </div>
      ) : (
        <div className="card p-8" data-testid="unsubscribe-confirm">
          <MailX className="w-12 h-12 text-cyan1 mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-black">Berhenti Menerima Email?</h1>
          <p className="text-slate-400 mt-2 text-sm">
            Anda akan berhenti menerima digest mingguan dan notifikasi berita di <span className="font-mono text-slate-300">{info.email}</span>.
            Langganan &amp; akses arsip digest Anda tetap aktif.
          </p>
          <button onClick={() => act("unsubscribe")} disabled={busy} className="btn-primary mt-6" data-testid="unsubscribe-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <MailX className="w-4 h-4" />} Ya, Hentikan Email
          </button>
        </div>
      )}
    </div>
  );
}
